import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbButton,
  makeStyles,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { SkanskaColorTokens } from "../style/colors";

const useStyles = makeStyles({
  button: {
    marginLeft: "5px",
    padding: "8px 8px",
    backgroundColor: SkanskaColorTokens.color_secondary_dim_white,
    "&:hover": {
      backgroundColor: SkanskaColorTokens.color_primary_gray,
    },
  },
});
export const AdminBreadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const classes = useStyles();
  if (location.pathname === "/") {
    return <></>;
  }

  return (
    <Breadcrumb aria-label={t("adminBreadcrumb")}>
      <BreadcrumbItem>
        <BreadcrumbButton
          onClick={() => navigate("/")}
          className={classes.button}
        >
          {t("adminStart")}
        </BreadcrumbButton>
      </BreadcrumbItem>
    </Breadcrumb>
  );
};
